
    /* eslint-disable */
    // @ts-nocheck
    // @ts-ignore
    var __STORY__ = "import groundNavMenu from '../../components/ground-nav/demo/menu.json';\nimport organization from '../../components/ground-nav/demo/organization.json';\nimport social from '../../components/ground-nav/demo/social.json';\nimport skyNavMenu from '../../components/sky-nav/demo/menu.json';\nimport { useSkyNav } from '../use-sky-nav.ts';\nimport './example/example.scss';\n\nimport singleArticlePrototype from './example/example.twig';\n\nexport default {\n  title: 'Prototypes/Article Series',\n  parameters: {\n    layout: 'fullscreen',\n  },\n};\n\nexport const Example = () => {\n  useSkyNav();\n  return singleArticlePrototype({\n    skyNavMenu,\n    menu: { items: [...skyNavMenu.items, ...groundNavMenu.items] },\n    social,\n    action: {\n      lead_in: 'Let’s discuss your project!',\n      title: 'Email us',\n      link: 'mailto:info@cloudfour.com',\n      icon: 'envelope',\n    },\n    organization: {\n      name: organization.name,\n      address: {\n        street_address: organization.address.street_address,\n        address_locality: organization.address.address_locality,\n        address_region: organization.address.address_region,\n        postal_code: organization.address.postal_code,\n        address_country: organization.address.address_country,\n      },\n      email: organization.email,\n      telephone: organization.telephone,\n      url: organization.url,\n      founding_date: organization.founding_date,\n    },\n  });\n};\n";
    // @ts-ignore
    var __LOCATIONS_MAP__ = {"Example":{"startLoc":{"col":23,"line":17},"endLoc":{"col":1,"line":44},"startBody":{"col":23,"line":17},"endBody":{"col":1,"line":44}}};
    
import groundNavMenu from '../../components/ground-nav/demo/menu.json';
import organization from '../../components/ground-nav/demo/organization.json';
import social from '../../components/ground-nav/demo/social.json';
import skyNavMenu from '../../components/sky-nav/demo/menu.json';
import { useSkyNav } from '../use-sky-nav.ts';
import './example/example.scss';

import singleArticlePrototype from './example/example.twig';

export default {
  title: 'Prototypes/Article Series',
  parameters: {
    layout: 'fullscreen',
  },
};

export const Example = () => {
  useSkyNav();
  return singleArticlePrototype({
    skyNavMenu,
    menu: { items: [...skyNavMenu.items, ...groundNavMenu.items] },
    social,
    action: {
      lead_in: 'Let’s discuss your project!',
      title: 'Email us',
      link: 'mailto:info@cloudfour.com',
      icon: 'envelope',
    },
    organization: {
      name: organization.name,
      address: {
        street_address: organization.address.street_address,
        address_locality: organization.address.address_locality,
        address_region: organization.address.address_region,
        postal_code: organization.address.postal_code,
        address_country: organization.address.address_country,
      },
      email: organization.email,
      telephone: organization.telephone,
      url: organization.url,
      founding_date: organization.founding_date,
    },
  });
};



Example.parameters = { storySource: { source: "() => {\n  useSkyNav();\n  return singleArticlePrototype({\n    skyNavMenu,\n    menu: { items: [...skyNavMenu.items, ...groundNavMenu.items] },\n    social,\n    action: {\n      lead_in: 'Let’s discuss your project!',\n      title: 'Email us',\n      link: 'mailto:info@cloudfour.com',\n      icon: 'envelope',\n    },\n    organization: {\n      name: organization.name,\n      address: {\n        street_address: organization.address.street_address,\n        address_locality: organization.address.address_locality,\n        address_region: organization.address.address_region,\n        postal_code: organization.address.postal_code,\n        address_country: organization.address.address_country,\n      },\n      email: organization.email,\n      telephone: organization.telephone,\n      url: organization.url,\n      founding_date: organization.founding_date,\n    },\n  });\n}" }, ...Example.parameters };